module.exports = __webpack_public_path__ + "static/media/LCA.8d6f3def.svg";